import React, { Component } from "react";
//import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Menu, MenuItem } from "@material-ui/core";
import { fetchMethod } from "../../../FetchMethod";
import {
  campaignContactStatusMutation,
  campaignContactLogMaintain
} from "../../../Queries";
import swal from "sweetalert";
import "./Engaged.css";

class NoOppTo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: this.props.target,
      convertTo: ["Suspect", "Prospect", "Opportunity"],
      campaignStatus: ["Live Campaign", "Engaged Contact", "Remove Contact"],
      limit: 0,
      offset: 0
    };
  }
  componentDidMount() {
    this.convertToClickList();
  }
  convertToList = () => {
    let convertToMessage = [];
    let campaignstatus = [];
    let contactstatus =
      this.props.contactStatus !== null
        ? this.props.contactStatus.toLowerCase()
        : "";
    let campStatus =
      this.props.campaignStatus != null
        ? this.props.campaignStatus.toLowerCase()
        : "";
    switch (campStatus) {
      case "live":
        campaignstatus[0] = "Pause Campaign";
        campaignstatus[2] = "Remove Contact";
        campaignstatus[3] = "Engaged Contact";
        break;
      case "pause":
        campaignstatus[0] = "Live Campaign";
        campaignstatus[2] = "Remove Contact";
        campaignstatus[3] = "Engaged Contact";

        break;
      default:
        campaignstatus[0] = "Live Campaign";
        campaignstatus[1] = "Pause Campaign";
        campaignstatus[2] = "Remove Contact";
        campaignstatus[3] = "Engaged Contact";
    }
    switch (contactstatus) {
      case "suspect":
        convertToMessage[0] = "Prospect";
        convertToMessage[1] = "Opportunity";
        break;
      case "prospect":
        convertToMessage[0] = "Suspect";
        convertToMessage[1] = "Opportunity";
        break;
      case "opportunity":
        convertToMessage[0] = "Suspect";
        convertToMessage[1] = "Prospect";
        break;
      default:
        convertToMessage[0] = "Suspect";
        convertToMessage[1] = "Prospect";
        convertToMessage[2] = "Opportunity";
    }
    this.setState({ convertTo: convertToMessage });
    this.setState({ campaignStatus: campaignstatus });
  };

  convertToClickList = () => {
    this.convertToList(this.state.anchorEl);
  };

  clickToConvertStatus = (e, newStatus, currentStatus) => {
    e.stopPropagation();
    let status = currentStatus !== null ? currentStatus.toLowerCase() : "";
    switch (status) {
      case "suspect":
        this.changeContactStatus(newStatus, status, this.props.id);
        break;
      case "prospect":
        this.changeContactStatus(newStatus, status, this.props.id);
        break;
      case "opportunity":
        this.changeContactStatus(newStatus, status, this.props.id);
        break;
      default:
        this.changeContactStatus(newStatus, status, this.props.id);
    }
    this.convertToClose();
  };

  changeContactStatus = (newStatus, status, id) => {
    let updateStatus = {};

    if (newStatus !== "NOOP") {
      updateStatus = {
        where: { id: id },
        data: {
          contactstatus: newStatus,
          updatedon: Date(Date.now()),

          noop: 0,
          leads: 1,
          updatedby: localStorage.getItem("id")
        }
      };
    } else {
      updateStatus = {
        where: { id: id },
        data: {
          contactstatus: newStatus,

          noop: 0,
          leads: 1,
          updatedon: Date(Date.now()),
          updatedby: localStorage.getItem("id")
        }
      };
    }
    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(campaignContactStatusMutation, updateStatus)
          .then(response => {
            return response.json();
          })

          .then(res => {
            if (res.data.ContactsUpsertWithWhere) {
              swal("Successfully converted", {
                icon: "success"
              }).then(() => {
                this.props.tableRerender.searchFetch(
                  this.props.limit,
                  this.props.offset
                );
              });

              this.logMaintain(newStatus, id);
            } else swal("Error", { icon: "error" });
          })
          .catch(err => {
            swal("Error", { icon: "error" });
          });
      }
    });
  };

  logMaintain = (newStatus, id) => {
    let newstatus = newStatus.toLowerCase();
    let updateLog = {};
    let createdBy = localStorage.getItem("id");
    switch (newstatus) {
      case "prospect":
        updateLog = {
          data: {
            contactid: id,
            leads: 1,
            action: "CONVERT_TO_PROSPECT",
            createdon: Date(Date.now()),
            createdby: createdBy
          }
        };
        break;
      case "suspect":
        updateLog = {
          data: {
            contactid: id,
            leads: 1,
            action: "CONVERT_TO_SUSPECT",
            createdon: Date(Date.now()),
            createdby: createdBy
          }
        };
        break;
      case "opportunity":
        updateLog = {
          data: {
            contactid: id,
            leads: 1,
            action: "CONVERT_TO_OPPORTUNITY",
            createdon: Date(Date.now()),
            createdby: createdBy
          }
        };
        break;
      case "noop":
        updateLog = {
          data: {
            contactid: id,
            action: "CONVERT_TO_NOOP",
            createdon: Date(Date.now()),
            createdby: createdBy
          }
        };
        break;
      default: {
      }
    }

    if (newStatus === "Pause Campaign") {
      updateLog = {
        data: {
          contactid: id,

          action: "CONVERT_TO_PAUSED",
          createdon: Date(Date.now()),
          createdby: createdBy
        }
      };
    }
    if (newStatus === "Live Campaign") {
      updateLog = {
        data: {
          contactid: id,

          action: "CONVERT_TO_LIVE",
          createdon: Date(Date.now()),
          createdby: createdBy
        }
      };
    }
    if (newStatus === "Remove Contact") {
      updateLog = {
        data: {
          contactid: id,

          action: "CONVERT_TO_REMOVE",
          createdon: Date(Date.now()),
          createdby: createdBy
        }
      };
    }
    if (newStatus === "Engaged Contact") {
      updateLog = {
        data: {
          contactid: id,

          action: "CONVERT_TO_ENGAGED",
          createdon: Date(Date.now()),
          createdby: createdBy
        }
      };
    }

    fetchMethod(campaignContactLogMaintain, updateLog)
      .then(response => {
        return response.json();
      })
      .then(res => res)
      .catch(e => console.log(e));
  };

  onClickToConvertCampaignStatus = (e, newStatus, currentStatus) => {
    e.stopPropagation();
   // let status = currentStatus !== null ? currentStatus.toLowerCase() : "";
    this.changeCampaignStatus(newStatus, this.props.id);
    this.props.onClose();
  };

  changeCampaignStatus = (newStatus, id) => {
    let newstatus = newStatus !== null ? newStatus.toLowerCase() : "";
    let updatedBy = localStorage.getItem("id");
    let updateStatus = {};

    if (newstatus === "live campaign") {
      updateStatus = {
        where: { id: id },
        data: {
          campaignstatus: "LIVE",
          noop: 0,
          contactstatus: null,
          updatedon: Date(Date.now()),
          updatedby: updatedBy
        }
      };
    }
    if (newstatus === "remove contact") {
      updateStatus = {
        where: { id: id },
        data: {
          active: 0,
          leads: 0,
          campaignstatus: "Pause",
          updatedon: Date(Date.now()),
          updatedby: updatedBy
        }
      };
    }
    if (newstatus === "engaged contact") {
      updateStatus = {
        where: { id: id },
        data: {
          engaged: 1,
          noop: 0,
          campaignstatus: "Pause",
          updatedon: Date(Date.now()),
          updatedby: updatedBy
        }
      };
    }

    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(campaignContactStatusMutation, updateStatus)
          .then(response => {
            return response.json();
          })
          .then(res => {
            if (res.data.ContactsUpsertWithWhere) {
              swal("Successfully converted", { icon: "success" }).then(() => {
                this.props.tableRerender.searchFetch(
                  this.props.limit,
                  this.props.offset
                );
              });
              this.logMaintain(newStatus, id);
            } else swal("Error", { icon: "error" });
          })
          .catch(err => {
            console.log(err);
            swal("Error", { icon: "error" });
          });
      }
    });
  };
  convertToClose = () => {
    const { onCloseEngagedPopup: cb } = this.props;
    cb && cb();
    this.setState({ anchorEl: null });
    this.props.onClose();
  };

  render() {
   // const { isOpen, id, target } = this.props;
    const { anchorEl, convertTo } = this.state;
    return (
      <div>

        <Menu
          id="statusMenu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          keepMounted
          style={{
            top:
              this.props.clientY < 340
                ? `${this.props.clientY}px`
                : `${this.props.clientY - 221}px`,
                       left:  this.props.clientX < 200
                ? `${this.props.clientX}px`
                : `${this.props.clientX - 150}px`
          }}
          onClose={this.convertToClose}
        >
          {this.state.campaignStatus.map((newCamp, key) => {
            return (
              <MenuItem
                key={key}
                onClick={e => {
                  this.onClickToConvertCampaignStatus(
                    e,
                    newCamp,
                    this.props.campaignStatus
                  );
                }}
              >
                {newCamp}
              </MenuItem>
            );
          })}
 
          <hr />
          <MenuItem
            style={{ color: "#2BADDD" }}
            onClick={this.convertToClose}
            disabled
          >
            Convert to
          </MenuItem>
          {convertTo.map((newstatus, key) => {
            return (
              <MenuItem
                key={key}
                onClick={e =>
                  this.clickToConvertStatus(
                    e,
                    newstatus,
                    this.props.contactStatus
                  )
                }
                style={{ marginLeft: "10px" }}
              >
                {newstatus}
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    );
  }
}

export default NoOppTo;
